<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/adminAccounts">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="system_user_id detail_content">
            <div class="system_user_id_label detail_label">
              {{ adminUserIdLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('adminUserId')"
            />
          </div>
          <div class="system_user_name detail_content">
            <div class="system_user_name_label detail_label">
              {{ adminUserNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('adminUserName')"
            />
          </div>
          <div class="authority detail_content">
            <div class="authority_label detail_label">
              {{ authorityLabel }}
            </div>
            <select
              class="drop_down_list"
              @change="inputAddUpdate('authority')"
            >
              <option :value="authority1">{{ authority1 }}</option>
              <option :value="authority2">{{ authority2 }}</option>
            </select>
          </div>
          <div class="mail_address detail_content">
            <div class="mail_address_label detail_label">
              {{ mailAddressLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('mailAddress')"
            />
          </div>
          <div class="password detail_content">
            <div class="password_label detail_label">
              {{ passwordLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="password"
              id="password"
              @input="inputAddUpdate('password')"
            />
          </div>
          <div class="confirm_password detail_content">
            <div class="confirm_password_label detail_label">
              {{ confirmPasswordLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="password"
              id="confirm_password"
            />
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addAdminAccount">
        </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      adminUserIdLabel: '管理者ID',
      adminUserNameLabel: '管理者名',
      authorityLabel: '管理者権限',
      authority1: 'ユーザ管理者',
      authority2: '閲覧ユーザ',
      mailAddressLabel: 'メールアドレス',
      passwordLabel: 'パスワード',
      confirmPasswordLabel: '確認用パスワード',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    authorty() {
      return this.$store.state.authory
    }
  },
  created() {
    this.$store.dispatch('adminAccounts/clearAddUpdate')
    this.$store.dispatch('adminAccounts/inputAddUpdate', {
      name: 'authority',
      value: this.authority1
    })
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('adminAccounts/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/adminAccounts')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addAdminAccount(e) {
      this.showloadingModal = true
      this.showConfirmPasswordModal = false
      let newPassword = document.getElementById('password').value
      let confirmPassword = document.getElementById('confirm_password').value
      if (newPassword === '' || confirmPassword === '') {
        this.showModal = false
        let eventNumber = this.$store.state.error.errorCode.errorCode_380001
        let reason = 'MSGCRC0095'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.errorMsg.MSGCRC0095.name +
          this.errorMsg.MSGCRC0095.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else if (newPassword !== confirmPassword) {
        this.showModal = false
        let eventNumber = this.$store.state.error.errorCode.errorCode_380001
        let reason = 'MSGCRC0067'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.errorMsg.MSGCRC0067.name +
          this.errorMsg.MSGCRC0067.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else {
        try {
          await this.$store.dispatch('adminAccounts/addAdminAccount')
          this.$emit('list-reload')
          this.showModal = false
          this.completeWord = '追加しました。'
          this.showCompleteModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_380001
          let eventType = 3
          let reason = ''
          if (
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.message
          ) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0064') {
              this.failureWord =
                this.errorMsg.MSGCRC0064.name +
                this.errorMsg.MSGCRC0064.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0065') {
              this.failureWord =
                this.errorMsg.MSGCRC0065.name +
                this.errorMsg.MSGCRC0065.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0066') {
              this.failureWord =
                this.errorMsg.MSGCRC0066.name +
                this.errorMsg.MSGCRC0066.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0094') {
              this.failureWord =
                this.errorMsg.MSGCRC0094.name +
                this.errorMsg.MSGCRC0094.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0109') {
              this.failureWord =
                this.errorMsg.MSGCRC0109.name +
                this.errorMsg.MSGCRC0109.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0110') {
              this.failureWord =
                this.errorMsg.MSGCRC0110.name +
                this.errorMsg.MSGCRC0110.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0111') {
              this.failureWord =
                this.errorMsg.MSGCRC0111.name +
                this.errorMsg.MSGCRC0111.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0112') {
              this.failureWord =
                this.errorMsg.MSGCRC0112.name +
                this.errorMsg.MSGCRC0112.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0125') {
              this.failureWord =
                this.errorMsg.MSGCRC0125.name +
                this.errorMsg.MSGCRC0125.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0126') {
              this.failureWord =
                this.errorMsg.MSGCRC0126.name +
                this.errorMsg.MSGCRC0126.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0127') {
              this.failureWord =
                this.errorMsg.MSGCRC0127.name +
                this.errorMsg.MSGCRC0127.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0133') {
              this.failureWord =
                this.errorMsg.MSGCRC0133.name +
                this.errorMsg.MSGCRC0133.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0068.name +
                this.errorMsg.MSGCRC0068.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else if (error.response && error.response.data) {
            reason = 'MSGCRC0068'
            eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0068.name +
              this.errorMsg.MSGCRC0068.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showModal = false
          this.showFailureModal = true
        }
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/adminAccounts/adminAccountAdd.vue